import React from 'react';
import { Helmet } from 'react-helmet-async';
import { cn } from '@/lib/utils';
import '@/i18n';
import { PublicThemeProvider, usePublicTheme } from '@/context/PublicThemeContext';
import { AccessibilityProvider } from '@/context/AccessibilityContext';
import { AccessibilityWidget } from '@/components/public/AccessibilityWidget';
import { PublicHeader } from '@/components/public/PublicHeader';
import { PublicFooter } from '@/components/public/PublicFooter';
import { CookieConsentProvider } from '@/context/CookieConsentContext';
import { CookieConsent } from '@/components/public/CookieConsent';
import { AssistantWidget } from '@/components/public/AssistantWidget';
import { organizationJsonLd, websiteJsonLd, SITE_ORIGIN } from '@/components/Seo';

const Shell = ({ children }) => {
  const { theme } = usePublicTheme();
  const origin = SITE_ORIGIN;
  return (
    <div className={cn('sila-public min-h-screen bg-background text-foreground', theme === 'dark' && 'dark')}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationJsonLd(origin))}</script>
        <script type="application/ld+json">{JSON.stringify(websiteJsonLd(origin))}</script>
      </Helmet>
      <PublicHeader />
      <main>{children}</main>
      <PublicFooter />
      <AccessibilityWidget />
      <CookieConsent />
      <AssistantWidget />
    </div>
  );
};

export const PublicLayout = ({ children }) => (
  <PublicThemeProvider>
    <AccessibilityProvider>
      <CookieConsentProvider>
        <Shell>{children}</Shell>
      </CookieConsentProvider>
    </AccessibilityProvider>
  </PublicThemeProvider>
);
